import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAlert } from "react-alert";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useDispatch, useSelector } from "react-redux";
import { getRoles, deleteRole, seedRoles } from "../../../actions/adminRoleActions";
import Loader from "../../Loader";
import { hasPermission, PERMISSIONS } from "../../../utils/permissions";

const ListRoles = ({ history }) => {
  const alert = useAlert();
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getRoles());
  }, [dispatch]);

  const { roles = [], loading, seeding, error } = useSelector(
    (state) => state.rolesList || {}
  );

  useEffect(() => {
    if (error) {
      alert.error(error);
    }
  }, [error, alert]);

  const handleDeleteRole = (id, name) => {
    confirmAlert({
      title: "Confirm Delete",
      message: `Are you sure you want to delete the role "${name}"?`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            dispatch(deleteRole(id));
            alert.success("Role deleted successfully");
            dispatch(getRoles());
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  const handleSeedRoles = () => {
    confirmAlert({
      title: "Seed Default Roles",
      message:
        "This will create default roles (superadmin, admin, editor, viewer) if they don't exist. Continue?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            await dispatch(seedRoles());
            alert.success("Default roles seeded successfully");
            dispatch(getRoles());
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  const roleList = Array.isArray(roles) ? roles : [];

  return (
    <Fragment>
      {loading ? (
        <Loader />
      ) : (
        <Fragment>
          <div className="content-wrapper">
            <section className="content-header">
              <h1>
                Roles <small>&amp; Permissions</small>
              </h1>
              <ol className="breadcrumb">
                <li>
                  <Link to="/admin">
                    <i className="fa fa-dashboard"></i> Dashboard
                  </Link>
                </li>
                <li className="active">Roles</li>
              </ol>
            </section>

            <section className="content">
              <div className="row">
                <div className="col-xs-12">
                  <div className="box">
                    <div className="box-header">
                      <h3 className="box-title">Roles</h3>
                      <div className="box-tools">
                        {user && user.isSuperAdmin && (
                          <button
                            className="btn btn-warning btn-sm"
                            onClick={handleSeedRoles}
                            disabled={seeding}
                            style={{ marginRight: 8 }}
                          >
                            {seeding ? "Seeding..." : "Seed Default Roles"}
                          </button>
                        )}
                        {hasPermission(user, PERMISSIONS.ROLES_CREATE) && (
                          <Link
                            to="/admin/roles/add"
                            className="btn btn-success btn-sm"
                          >
                            + Add Role
                          </Link>
                        )}
                      </div>
                    </div>
                    <div className="box-body table-responsive no-padding">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Label</th>
                            <th>Permissions</th>
                            <th>System</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {roleList.length ? (
                            roleList.map((role) => (
                              <tr key={role._id}>
                                <td>{role.name}</td>
                                <td>{role.label || role.name}</td>
                                <td>
                                  <span className="badge bg-blue">
                                    {role.permissions
                                      ? role.permissions.length
                                      : 0}
                                  </span>
                                </td>
                                <td>
                                  {role.isSystem ? (
                                    <span className="label bg-yellow">
                                      System
                                    </span>
                                  ) : (
                                    <span className="label bg-gray">
                                      Custom
                                    </span>
                                  )}
                                </td>
                                <td>
                                  {hasPermission(
                                    user,
                                    PERMISSIONS.ROLES_EDIT
                                  ) && (
                                    <Link
                                      to={`/admin/roles/edit/${role._id}`}
                                      className="btn btn-success btn-sm"
                                      title="Edit"
                                    >
                                      <i className="fa fa-edit"></i>
                                    </Link>
                                  )}
                                  &nbsp;
                                  {hasPermission(
                                    user,
                                    PERMISSIONS.ROLES_DELETE
                                  ) &&
                                    !role.isSystem && (
                                      <a
                                        className="btn btn-danger btn-sm"
                                        title="Delete"
                                        onClick={() =>
                                          handleDeleteRole(
                                            role._id,
                                            role.name
                                          )
                                        }
                                      >
                                        <i className="fa fa-trash"></i>
                                      </a>
                                    )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5" className="text-center">
                                No roles found. Click "Seed Default Roles" to
                                create default roles.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default ListRoles;
